import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { resourceList } from "@/mocks/resources";

export default function FeaturedResources() {
  const items = resourceList.slice(0, 3);

  return (
    <section data-product-shop className="px-4 md:px-8 py-14 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            eyebrow="推荐资源"
            title="精选资源，即取即用"
            description="白皮书、研究报告与实用工具，助力你更深入地了解品牌与行业。"
          />
          <Link
            to="/resources"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap"
          >
            全部资源
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <Link
              key={item.id}
              to={`/resources/${item.id}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/95 px-3 py-1 text-xs font-medium text-primary-700">
                  {item.type}
                </span>
              </div>
              <div className="flex flex-1 flex-col gap-3 p-5">
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 group-hover:text-primary-600">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600 line-clamp-2">
                  {item.summary}
                </p>
                <div className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {item.updatedAt}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-secondary-900">
                    {item.field}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}